import { LockOutlined } from '@mui/icons-material';
import {
  Alert,
  AlertTitle,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  TextField,
  Typography,
} from '@mui/material';
import { useErrorAlert, getApiErrorMessage } from 'lib/ErrorAlert';
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

export const LoginScreen = () => {
  const { isLoading, login } = useAuth();
  const [error, setError] = useState<{ title?: string; body: string } | null>(null);
  const { clearErrors } = useErrorAlert();

  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlined />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Ecois Client ログイン
        </Typography>
        {error && (
          <Alert sx={{ width: '100%' }} severity='error'>
            {error.title && <AlertTitle>{error.title}</AlertTitle>}
            {error.body}
          </Alert>
        )}
        <Box
          component='form'
          onSubmit={(e) => {
            e.preventDefault();
            const username = (e.target as HTMLFormElement).username.value.trim();
            const password = (e.target as HTMLFormElement).password.value;
            if (!username || !password) {
              setError({
                title: '入力エラー',
                body: 'Username または Email とパスワードを入力してください。',
              });
              return;
            }
            login({ username, password })
              .then(() => {
                setError(null);
                clearErrors();
              })
              .catch((e) => {
                setError({ body: getApiErrorMessage(e) });
              });
          }}
          noValidate
          sx={{ mt: 1 }}
        >
          <TextField
            margin='normal'
            required
            fullWidth
            id='username'
            label='Username または Email'
            name='username'
            autoComplete='username'
            tabIndex={0}
          />
          <TextField
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            type='password'
            id='password'
            autoComplete='current-password'
          />
          <Button
            disabled={isLoading}
            type='submit'
            fullWidth
            variant='contained'
            sx={{ mt: 3, mb: 2 }}
          >
            {!isLoading ? 'ログイン' : <CircularProgress color='secondary' />}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};
